<section id="home" class="section welcome-area bg-overlay bg-overlay-color1-step2 overflow-hidden d-flex align-items-center" style="padding-top: 100px; height: 500px; z-index: 1;">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <!-- Welcome Intro Start -->
            <div class="col-12 col-md-10">
                <div class="welcome-intro text-center mt-0 py-5">
                    <h1 class="text-white">Opportunity is knocking.<br>Are you going to answer the call?</h1>
                    <p class="text-white my-4">We're proud of the work that we do, so much so that we want to show everyone else how awesome we can be, so we strongly believe in and wish for your company's success.</p>
                    <!-- Buttons -->
                    <div class="button-group">
                        <a (click)="openContactModal()" class="btn btn-bordered-white d-none d-sm-inline-block">Contact Us</a>
                        <a [routerLink]="'/process'" class="btn btn-bordered-white">View Process</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Shape Bottom -->
    <div class="shape shape-bottom" style="transform: rotate(180deg); bottom: -45px;">
        <svg viewBox="0 0 1000 100" fill="#FFF " xmlns="http://www.w3.org/2000/svg">
            <path class="shape-fill" d="M -2.221 61.262 C -2.221 61.262 14.52 73.062 66.911 81.92 C 107.24 88.739 166.135 49.176 166.135 49.176 C 284.966 0.108 722.057 1.013 815.035 44.405 C 815.035 44.405 919.473 85.664 963.373 78.183 C 982.616 74.903 1004.117 59.168 1001.556 55.115 L 1000.798 -2.133 L -0.343 -1.092 L -2.221 61.262 Z"/>
          </svg>
    </div>
</section>

<section class="section about-area ptb_100">
    <div class="container">
        <div class="row justify-content-between align-items-center">
            <div class="col-12 col-lg-6">
                <!-- About Thumb -->
                <div class="about-thumb text-center">
                    <img src="assets/img/about_thumb_1.jpg" alt="">
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <!-- About Content -->
                <div class="about-content section-heading text-center text-lg-left pl-md-4 mt-5 mt-lg-0 mb-0">
                    <h2 class="mb-3" style="font-size: 2.5rem">Our Mission Statement</h2>
                    <p>When a family member started his own small business, he soon discovered the amount of money that goes into digital marketing. 
                        This unforunately meant that hiring an agency would not be within the budget; 
                        Seeing him struggle with this gave me the idea of providing an affordable solution for local business owners who are wary of the RoI (Return on Investment) on the money spent in marketing.  </p>
                        <br>
                    <p>We understand that as a business owner you need to make informed decisions for your company based on factual data. And we are here to help you determine if the RoI is better than you anticipated with our data-driven results.</p>
                    <!-- Counter Area -->
                    <div class="couter-area mt-5">
                        <!-- Single Counter -->
                        <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                            <div class="counter-inner">
                                <!-- Counter Item -->
                                <div class="counter-item d-inline-block mb-3">
                                    <span class="counter color-1 fw-7">3</span><span class="color-1 fw-7">+</span>
                                </div>
                            </div>
                            <h4 class="text-uppercase fw-7">Happy Clients</h4>
                        </div>
                        <!-- Single Counter -->
                        <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                            <div class="counter-inner">
                                <!-- Counter Item -->
                                <div class="counter-item d-inline-block mb-3">
                                    <span class="counter color-2 fw-7">5</span><span class="color-2 fw-7">+</span>
                                </div>
                            </div>
                            <h4 class="text-uppercase fw-7">Projects Completed</h4>
                        </div>
                        <!-- Single Counter -->
                        <div class="single-counter d-block d-md-inline-block m-4 m-md-2">
                            <div class="counter-inner">
                                <!-- Counter Item -->
                                <div class="counter-item d-inline-block mb-3">
                                    <span class="counter color-3 fw-7">3</span><span class="color-3 fw-7">+</span>
                                </div>
                            </div>
                            <h4 class="text-uppercase fw-7">Running Projects</h4>
                        </div>
                    </div>
                    <p style="color: #0009; font-size: 85%; text-align: center; align-self: center;">we're not here to inflate our numbers and lie to you, these are genuine numbers and we're excited to continue growing</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section team-area bg-grey ptb_100">
    <!-- Shape Top -->
    <div class="shape shape-top">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
        c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
        c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-10 col-lg-7">
                <!-- Section Heading -->
                <div class="section-heading text-center">
                    <h2>Our Founder</h2>
                    <!-- <p class="d-none d-sm-block mt-4">.</p>
                    <p class="d-block d-sm-none mt-4">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laborum obcaecati.</p> -->
                </div>
            </div>
        </div>
        <div class="row justify-content-center">
            <div class="col-4">
                <img src="{{teamMembers[0].image}}" alt="">
                <h5 class="reviewer-name color-primary mb-2" style="text-align:center;">{{teamMembers[0].name}}</h5>
                <h6 class="text-secondary fw-3" style="text-align:center;">{{teamMembers[0].title}}</h6>
            </div>
            <div class="col-12 col-lg-5" style="text-align: left;">
                <p>Alan has developed a sense of fulfillment in his decade working in the tech industry starting straight out of high school. Despite having a quite fullfilling role in his current employment, he wishes to expand into new horizons and become a small business owner with the hopes of helping other small business owners.</p><br>
                <p>Some other additional information about Alan that pertains to the business</p>
                <ul style="margin-top: 25px;">
                    <li>Favorite Music: Trance and House Music</li>
                    <li>Favorite Hobby: Building old Subarus for racing events</li>    
                </ul>
            </div>
            
           <!-- <owl-carousel-o [options]="customOptions" class="team">
            <ng-container class="single-team p-5" *ngFor="let review of teamMembers">
                <ng-template carouselSlide [id]="review.id">
                    <div class="team-photo">
                        <img src="{{review.image}}" alt="">
                    </div>
                    <div class="team-content p-3">
                        <h5 class="reviewer-name color-primary mb-2">{{review.name}}</h5>
                        <h6 class="text-secondary fw-3">{{review.title}}</h6>
                    </div>
                </ng-template>
            </ng-container>
        </owl-carousel-o> -->
        </div>
    </div>
    <!-- Shape Bottom -->
    <!-- <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#FFFFFF">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div> -->
</section>

<section class="section cta-area bg-overlay bg-overlay-color1 ptb_100">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-lg-10">
                <!-- Section Heading -->
                <div class="section-heading text-center m-0">
                    <h2 class="text-white">Ready to grow your business?</h2>
                    <a (click)="openContactModal()" class="btn btn-bordered-white mt-4">Contact Us</a>
                </div>
            </div>
        </div>
    </div>
</section>